import { Injectable } from '@angular/core';
import { BackendService } from '../backend.service';
import { ShieldUpdate, ShieldPayload } from './risk';
import { Observable } from 'rxjs';

@Injectable()
export class ShieldService {

  private shieldBackendUpdateUrl = '/mfa/api/v1/sessions/{sessionID}';

  constructor(private backendService: BackendService) { }

  activateShield(shieldSessionId: string, payload: ShieldPayload): Observable<ShieldUpdate> {
    return this.backendService.putData(this.shieldBackendUpdateUrl.replace('{sessionID}', shieldSessionId), payload);
  }
}
